if (typeof boostPFSThemeConfig !== 'undefined') {
  // Override Settings
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      loadProductFirst: true,
      numberFilterTree: 2,
      selectOptionContainer: '.grid__item .card-wrapper',
      stickyFixTopPos: true
    },
    selector: {
      otpTopCartCount: '.cart-count-bubble'
    }
  };
}

(function () {
  var onSale = false,
    soldOut = false,
    priceVaries = false,
    images = [],
    boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];


  BoostPFS.inject(this);
  /* For Filter Setting Layout */
  Selector.stickyElementDesktop = jQ('.boost-pfs-filter-left-col').length > 0 && !Utils.isMobile() ? '.boost-pfs-filter-left-col' : '.boost-pfs-filter-tree';
  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    return data;
  }

  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Add Custom class
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
    var saleClass = onSale ? boostPFSTemplate.saleClass : '';
    var ratioImage = getRatioImage(data);
    var imageAspectRatio = ratioImage / getAspectRatio(data.images_info[0]) * 100;

    itemHtml = itemHtml.replace(/{{imageAspectRatio}}/g, imageAspectRatio);

    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);


    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    // Add Card product class
    itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass(data));
    // Add Card inner product class
    itemHtml = itemHtml.replace(/{{cardInnerProductClass}}/g, buildCardInnerProductClass(data));
    // Add Card badge position
    itemHtml = itemHtml.replace(/{{cardBadgePosition}}/g, boostPFSThemeConfig.custom.badge_position);
    // Add check card heading five
    itemHtml = itemHtml.replace(/{{cardIsHeadingFive}}/g, buildCardIsHeadingFive(data));
    // Add sold out Label
    itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
    // Add sale Label
    itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

    // Add custome label
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
    // Add custome add cart and shipping time
    itemHtml = itemHtml.replace(/{{itemCartAndTime}}/g, buildCartAndTime(data));

    // Add Review
    if (typeof Integration === 'undefined' ||
      (typeof Integration != 'undefined' &&
        typeof Integration.hascompileTemplate == 'function' &&
        !Integration.hascompileTemplate('reviews'))) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
    }

    // Add Description
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, boostPFSThemeConfig.custom.description || '');

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    /* Swym integration */
    var itemWishlistHtml = '<div class="add-to-wl"><button class="wl-js swym-button swym-add-to-wishlist-view-product product_{{itemId}}" data-swaction="addToWishlist"  data-product-id="' + JSON.stringify(data.id) + '"></button></div>';
    itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

    // align height
    function alignHeight(selector, n) {
      var items = jQuery(selector);
      var newArrays = new Array(Math.ceil(items.length / n))
        .fill()
        .map(_ => items.splice(0, n))

      $(newArrays).each(function () {
        jQuery(this).css('height', '');
        var minHeight = 0;
        jQuery(this).each(function () {
          if (minHeight < jQuery(this).outerHeight()) {
            minHeight = jQuery(this).outerHeight();
          }
        });
        if (minHeight > 0) {
          jQuery(this).css('height', minHeight);
        }
      });
    }
    setTimeout(function () {
      if ($(window).width() > 1200) {
        alignHeight('.card-wrapper .h5.card__heading', 4);
        alignHeight('.card-wrapper .card__inner', 4);
        alignHeight('.card-wrapper .price__container', 4);
      } else if ($(window).width() < 750) {
        alignHeight('.card-wrapper .h5.card__heading', 2);
        alignHeight('.card-wrapper .card__inner', 2);
        alignHeight('.card-wrapper .price__container', 2);
      } else {
        alignHeight('.card-wrapper .h5.card__heading', 3);
        alignHeight('.card-wrapper .card__inner', 3);
        alignHeight('.card-wrapper .price__container', 3);
      }
    }, 500);
    jQuery(window).resize(function () {
      if ($(window).width() > 1200) {
        alignHeight('.card-wrapper .h5.card__heading', 4);
        alignHeight('.card-wrapper .card__inner', 4);
        alignHeight('.card-wrapper .price__container', 4);
      } else if ($(window).width() < 750) {
        alignHeight('.card-wrapper .h5.card__heading', 2);
        alignHeight('.card-wrapper .card__inner', 2);
        alignHeight('.card-wrapper .price__container', 2);
      } else {
        alignHeight('.card-wrapper .h5.card__heading', 3);
        alignHeight('.card-wrapper .card__inner', 3);
        alignHeight('.card-wrapper .price__container', 3);
      }
    });

    return itemHtml;
  };

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/

  function buildRrp(data) {
    var html = '';
    var metaFields = data.metafields;
    metaFields.forEach(function (metafield) {
      if (metafield.key == "rrp") {
        var rrpPrice = metafield.value;
        var stringTONumber = Number(rrpPrice);
        var priceFormat = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(stringTONumber, 'money_with_currency') : Utils.formatMoney(stringTONumber);
        html += `<div class="rrp-price">
                  <span>RRP ${priceFormat}</span>
                  </div>`;
      }
    });
    return html;
  }

  function buildRrpLabels(data) {
    var html = '';
    var priceAmount = data.price_min;
    var compareAtPrice = data.compare_at_price_min;
    var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, priceAmount) : priceAmount;
    var metaFields = data.metafields;
    metaFields.forEach(function (metafield) {
      if (metafield.key == "rrp") {
        var rrpPrice = metafield.value;
        var priceLabel = Math.round(rrpPrice - priceAmount);
        var priceLabelFormat = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(priceLabel, 'money_with_currency') : Utils.formatMoney(priceLabel);
        var priceLabelFormat = priceLabelFormat.replace('.00', '')

        if (compareAtPrice > priceAmount) {
          html += `<div class="rrp-compare"><p class="text-save">Save ${priceLabelFormat}!</p></div>`;
        } else {
          html += `<div class="rrp-no-compare"><span class="text-save">Save ${priceLabelFormat}</span></div>`;
        }
      }
    });
    return html;
  }

  function buildLabels(data) {
    if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
      var html = '';

      html += '<div class="sold-out-label">';
      html += '<span>Sold out</span>';
      html += '</div>';

      return html;
    } else {
      var html = '';
      var metaFields = data.metafields;
      metaFields.forEach(function (metafield) {
        if (metafield.key == "free_shipping_label") {
          html += `<div class="free-ship-label">
                    <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.466 7.125H12.1535V5.01562C12.1535 4.78125 12.0363 4.52734 11.8605 4.35156L9.92695 2.41797C9.75116 2.24219 9.49726 2.125 9.26288 2.125H8.40351V1.1875C8.40351 0.679688 7.97382 0.25 7.46601 0.25H2.46601C1.93866 0.25 1.52851 0.679688 1.52851 1.1875V2.125H0.434759C0.337102 2.125 0.278509 2.20312 0.278509 2.28125V2.59375C0.278509 2.69141 0.337102 2.75 0.434759 2.75H5.74726C5.82538 2.75 5.90351 2.82812 5.90351 2.90625V3.21875C5.90351 3.31641 5.82538 3.375 5.74726 3.375H1.05976C0.962102 3.375 0.903509 3.45312 0.903509 3.53125V3.84375C0.903509 3.94141 0.962102 4 1.05976 4H5.12226C5.20038 4 5.27851 4.07812 5.27851 4.15625V4.46875C5.27851 4.56641 5.20038 4.625 5.12226 4.625H0.434759C0.337102 4.625 0.278509 4.70312 0.278509 4.78125V5.09375C0.278509 5.19141 0.337102 5.25 0.434759 5.25H4.49726C4.57538 5.25 4.65351 5.32812 4.65351 5.40625V5.71875C4.65351 5.81641 4.57538 5.875 4.49726 5.875H1.52851V8.375C1.52851 9.41016 2.36835 10.25 3.40351 10.25C4.43866 10.25 5.27851 9.41016 5.27851 8.375H7.77851C7.77851 9.41016 8.61835 10.25 9.65351 10.25C10.6887 10.25 11.5285 9.41016 11.5285 8.375H12.466C12.6223 8.375 12.7785 8.23828 12.7785 8.0625V7.4375C12.7785 7.28125 12.6223 7.125 12.466 7.125ZM3.40351 9.3125C2.87616 9.3125 2.46601 8.90234 2.46601 8.375C2.46601 7.86719 2.87616 7.4375 3.40351 7.4375C3.91132 7.4375 4.34101 7.86719 4.34101 8.375C4.34101 8.90234 3.91132 9.3125 3.40351 9.3125ZM9.65351 9.3125C9.12616 9.3125 8.71601 8.90234 8.71601 8.375C8.71601 7.86719 9.12616 7.4375 9.65351 7.4375C10.1613 7.4375 10.591 7.86719 10.591 8.375C10.591 8.90234 10.1613 9.3125 9.65351 9.3125ZM11.216 5.25H8.40351V3.0625H9.26288L11.216 5.01562V5.25Z" fill="#0FDA37"/>
                    </svg>
                    <span>${metafield.value}</span>
                  </div>`;
        }
      });

      var priceAmount = data.price_min;
      var compareAtPrice = data.compare_at_price_min;
      var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, priceAmount) : priceAmount;
      html += '<div class="float-label">';
      metaFields.forEach(function (metafield) {
        if (metafield.key == "set_product_as_new") {
          html += '<div class="is-new"><p>NEW </p><p>ITEM</p></div>';
        }
      });
      var rrpPrice = 0;
      metaFields.forEach(function (metafield) {
        if (metafield.key == "rrp") {
          rrpPrice = metafield.value;
        }
      });
      if (rrpPrice > moneyPrice && compareAtPrice > 0) {
        var percent = ((rrpPrice - moneyPrice) / rrpPrice * 100).toFixed(0);
        html += '<div class="sale-label"><p><span>' + percent + '</span><span>%</span></p><p>OFF</p></div>';
      }
      html += '</div>';

      return html;
    }
  }

  function buildCartAndTime(data) {
    var html = '';
    var productVariants = data.variants;
    var bundleList = data.metafields.find(obj => {
      return obj.namespace === 'bundle'
    })
    var input = ""
    if (bundleList) {
      arrayBundleList = bundleList.value.replace("[", "").replace("]", "").replace('"', '').split(",");
      for (i = 0; i < arrayBundleList.length; i ++) {
        var productHandle = arrayBundleList[i].replace('"', '').replace('"', '');
        var bundleProductSKU =""
        var productTitle = ""
        $.ajax({
          url: window.Shopify.routes.root + `products/${productHandle}.js`,
          async: false,
          dataType: 'json',
          success: function(product) {
            bundleProductSKU = product.variants[0].sku;
            productTitle = product.title
          }
        });
        input += `<input hidden type='text' name='properties[${productTitle}]' value='${bundleProductSKU} | 1'>`
      }
    }
    if (data.available) {
      if (productVariants > 1) {
        html += '<a href="" class="goto-product"><img src="/assets/cart-outline.png" alt=""></a>';
      } else {
        html += `
        <product-form class="product-form">
          <div class="product-form__error-message-wrapper" role="alert" hidden="">
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path></svg>
            <span class="product-form__error-message"></span>
          </div>
          <form method="post" action="/cart/add" id="" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
            <input type="hidden" name="form_type" value="product">
            <input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="${productVariants[0].id}">
            ${input}
            <div class="product-form__buttons">
              <button type="submit" name="add" class="product-form__submit button button--full-width button--primary boost-pfs-action-overlay">
                <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.03964 16C6.38753 16 6.66956 15.718 6.66956 15.3701C6.66956 15.0222 6.38753 14.7402 6.03964 14.7402C5.69174 14.7402 5.40971 15.0222 5.40971 15.3701C5.40971 15.718 5.69174 16 6.03964 16Z" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.8585 16C15.2064 16 15.4884 15.718 15.4884 15.3701C15.4884 15.0222 15.2064 14.7402 14.8585 14.7402C14.5106 14.7402 14.2286 15.0222 14.2286 15.3701C14.2286 15.718 14.5106 16 14.8585 16Z" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/><path d="M1 2.14169H3.51969L5.40945 12.8504H15.4882" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.40971 10.3307H15.2302C15.303 10.3308 15.3736 10.3056 15.43 10.2594C15.4863 10.2132 15.5249 10.149 15.5392 10.0776L16.6731 4.40827C16.6822 4.36256 16.6811 4.31538 16.6698 4.27015C16.6585 4.22492 16.6373 4.18276 16.6078 4.14671C16.5782 4.11066 16.541 4.08163 16.4989 4.06171C16.4567 4.04178 16.4107 4.03147 16.364 4.0315" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/><line x1="11.4005" y1="0.7" x2="11.4005" y2="6.35512" stroke="white" stroke-width="1.4" stroke-linecap="round"/><line x1="8.37705" y1="3.33149" x2="14.0322" y2="3.33149" stroke="white" stroke-width="1.4" stroke-linecap="round"/><line x1="4.3456" y1="3.33149" x2="5.96922" y2="3.33149" stroke="white" stroke-width="1.4" stroke-linecap="round"/></svg>
                <div class="text-add">Add</div>
                <div class="loading-overlay__spinner hidden">
                  <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                  </svg>
                </div>
              </button>
            </div>
          </form>
        </product-form>`;
      }
    }

    return html;
  }

  function buildImages(data) {
    var html = '';
    if (images && Array.isArray(images) && images.length > 0) {
      html += '<div class="card__media">';
      var aspectRatio = '',
        rangeWidths = boostPFSRangeWidths;

      var dataSrcSet = '',
        imgAlt = data.title,
        flipImageSrcSet = '';

      var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
        boostPFSThemeConfig.custom.hasOwnProperty('show_secondary_image') &&
        boostPFSThemeConfig.custom.show_secondary_image == true;

      for (var i = 0; i < rangeWidths.length; i++) {
        dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';

        if (activeSwapImage) {
          flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
        }

        if (i < rangeWidths.length - 1) {
          dataSrcSet += ', ';

          if (activeSwapImage) {
            flipImageSrcSet += ', ';
          }
        }
      }

      aspectRatio = images[0]['width'] / images[0]['height'];
      html += '<div class="media media--transparent media--hover-effect"><img class="motion-reduce"' +
        'loading="lazy"' +
        'srcset="' + dataSrcSet + '" ' +
        'height="' + images[0].height + '" ' +
        'width="' + images[0].width + '" ' +
        'sizes="(min-width: 1100px) 535px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"' +
        'src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
        'alt="' + imgAlt + '" />';

      if (activeSwapImage) {
        html += '<img class="motion-reduce"' +
          'loading="lazy"' +
          'srcset="' + flipImageSrcSet + '" ' +
          'height="' + images[1].height + '" ' +
          'width="' + images[1].width + '" ' +
          'sizes="(min-width: 1100px) 535px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"' +
          'src="' + Utils.optimizeImage(images[1].src, '533x') + '" ' +
          'alt="' + imgAlt + '" />';
      }
      html += '</div>';
      html += '</div>';
    } else {
      html += `<div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading">
                    <a href="#" class="full-unstyled-link">
                      ${data.title}
                    </a>
                  </h3>
                </div>
              </div>`;
    }
    return html;
  }

  function buildCardProductClass(data) {
    var html = '' + boostPFSThemeConfig.custom.card_style;
    if (!images) {
      html += ' card--text';
    } else {
      html += ' card--media';
    }
    if (boostPFSThemeConfig.custom.card_style == 'card') {
      html += ' color-' + boostPFSThemeConfig.custom.card_color_scheme;
    }
    if (!images && boostPFSThemeConfig.custom.card_style == 'card') {
      html += ' ratio';
    }
    return html;
  }

  function buildCardInnerProductClass(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.card_style == 'standard') {
      html += ' color-' + boostPFSThemeConfig.custom.card_color_scheme;
    }
    if (images || boostPFSThemeConfig.custom.card_style == 'standard') {
      html += ' ratio';
    }
    return html;
  }

  function buildCardIsHeadingFive(data) {
    var html = '';
    if (images || boostPFSThemeConfig.custom.card_style == 'standard') {
      html = 'h5';
    }
    return html;
  }

  function buildVendor(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
      boostPFSThemeConfig.custom.show_vendor === true) {
      html = boostPFSTemplate.vendorHtml;
    }
    return html;
  }

  function buildPrice(data) {
    var html = '';
    var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
    var priceAmount = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.price_min, 'money_with_currency') : Utils.formatMoney(data.price_min);
    if (data.compare_at_price_min > 0) {
      var compareAtPrice = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.compare_at_price_min, 'money_with_currency') : Utils.formatMoney(data.compare_at_price_min);
    }
    var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, priceAmount) : priceAmount;
    moneyPrice = moneyPrice.replace("From", "");
    var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : ''
    html = `<div class="price ${soldOut ? 'price--sold-out' : ''} ${onSale ? 'price--on-sale' : ''}${noComparePrice ? 'price--no-compare' : ''}">
          <div class="price__container">
            ${buildRrp(data)}
            <span class="regular-in-sale on-mobile">
              <s class="price-item price-item--regular">
                ${compareAtPrice ? '(Was '+ compareAtPrice + ')': '' }
              </s>
            </span>
            <div class="price__regular">
              <span class="visually-hidden visually-hidden--inline">
                ${boostPFSConfig.label.regular_price}
              </span>
              <span class="price-item price-item--regular">
                ${moneyPrice}
              </span>
            </div>
            ${buildRrpLabels(data)}
            <div class="price__sale">
            <span class="visually-hidden visually-hidden--inline">${boostPFSConfig.label.sale_price}</span>
              <span class="price-item price-item--sale price-item--last">
                <span class="text-price-sale">Now</span>
                ${moneyPrice}
                ${buildRrpLabels(data)}
              </span>
              <span class="visually-hidden visually-hidden--inline">
                ${boostPFSConfig.label.regular_price}
              </span>
              <span class="regular-in-sale">
                <s class="price-item price-item--regular">
                  (Was ${compareAtPrice})
                </s>
              </span>
              ${buildRrpLabels(data)}
            </div>
            <small class="unit-price caption ${unitPriceClass}">
              <span class="visually-hidden">${boostPFSConfig.label.unit_price}</span>
              <span class="price-item price-item--last">
                <span>${Utils.formatMoney(data.selected_or_first_available_variant && data.selected_or_first_available_variant.unit_price)}</span>
                <span aria-hidden="true">/</span>
                <span class="visually-hidden">&nbsp;${boostPFSConfig.label.unit_price_separator}&nbsp;</span>
              </span>
            </small>
          </div>
        </div>`
    return html;
  }

  function buildSoldOutLabel() {
    // Build Sold out label
    var soldOutLabel = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
      soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{soldOutBadgeClass}}/g, boostPFSThemeConfig.custom.sold_out_badge_color_scheme);
    }
    return soldOutLabel;
  }

  function buildSaleLabel() {
    // Build Sale label
    var saleLabel = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') && onSale && !soldOut) {
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{saleBadgeClass}}/g, boostPFSThemeConfig.custom.sale_badge_color_scheme);
    }
    return saleLabel;
  }

  function buildReview(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
      boostPFSThemeConfig.custom.show_product_review == true && Utils.getProductMetafield(data, 'reviews', 'rating') !== null) {
      var ratingObj = JSON.parse(Utils.getProductMetafield(data, 'reviews', 'rating'));
      var rating_decimal = 0;
      var decimal = parseFloat(ratingObj.value.rating);
      if (decimal >= 0.3 && decimal <= 0.7) {
        rating_decimal = 0.5;
      } else if (decimal > 0.7) {
        rating_decimal = 1;
      }
      html = `<div class="rating" role="img" aria-label="${boostPFSConfig.label.star_reviews_info.replace('{{ rating_value }}', ratingObj.value).replace('{{ rating_max }}', ratingObj.value.scale_max)}">
                <span aria-hidden="true" class="rating-star color-icon-${boostPFSConfig.custom.accent_icons}" style="--rating: ${Math.round(ratingObj.value.rating)}; --rating-max: ${ratingObj.value.scale_max}; --rating-decimal: ${rating_decimal};"></span>
              </div>
              <p class="rating-text caption">
                <span aria-hidden="true">${ratingObj.value} / ${ratingObj.value.scale_max}</span>
              </p>
              <p class="rating-count caption">
                <span aria-hidden="true">(${Utils.getProductMetafield(data, 'reviews', 'rating_count')})</span>
                <span class="visually-hidden">${Utils.getProductMetafield(data, 'reviews', 'rating_count')} ${boostPFSConfig.label.total_reviews}</span>
              </p>`;
    }
    return html;
  }

  function getAspectRatio(data) {
    var width = (data == null) ? '535' : data.width;
    var height = (data == null) ? '535' : data.height;

    return width / height;
  }

  function getRatioImage(data) {
    var ratio = 1;
    if (images && boostPFSThemeConfig.custom.media_size == 'portrait') {
      ratio = 0.8;
    } else if (images && boostPFSThemeConfig.custom.media_size == 'adapt') {
      ratio = getAspectRatio(data.images[0]);
    }
    if (ratio === 0 || ratio === null) {
      ratio = 1;
    }
    return ratio;
  }

  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = '';
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        var paramSort = Globals.queryParams.sort || '';
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          var isSelected = ''
          if (paramSort == k) {
            isSelected = 'selected="selected"'
          }
          sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  ProductSorting.prototype.render = function () {
    jQ(Selector.topSorting).html(this.compileTemplate());

    if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
      jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
    }

    var labelSort = '';
    var paramSort = Globals.queryParams.sort || '';
    var sortingList = Utils.getSortingList();
    if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
      labelSort = sortingList[paramSort];
    } else {
      labelSort = Labels.sorting;
    }

    jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
  }

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function () {
    jQ(Selector.topSorting + ' .facet-filters__sort').change(function (e) {
      e.preventDefault();
      FilterApi.setParam('sort', jQ(this).val());
      FilterApi.setParam('page', 1);
      FilterApi.applyFilter('sort');
    });
  };

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data) {
    if (!data) data = this.data;

    /** Start Swym integration **/
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function (swat) {
      // Wrap with callback for loading without additional checks
      var products = [];
      data.forEach(function (product) {
        var image_src = Utils.getFeaturedImage(product.images_info);
        var productCopy = product;
        productCopy.featured_image = image_src;
        productCopy.price = product.price_min; // Sometimes I need to multiply the price with 100
        productCopy.compare_at_price = product.compare_at_price_min; // Sometimes I need to multiply the price with 100
        products.push(productCopy);
      });
      swat.mapShopifyProducts(products); // Product mapped data to swym layer
      swat.initializeActionButtons('.boost-pfs-filter-products'); // Buttons can now be initialized
    });
    /** End Swym integration **/
  }

  // Build Additional Elements
  Filter.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    jQ('.boost-pfs-filter-total-product').html(data.total_product + ' results');
  };

  /************************** END BUILD TOOLBAR **************************/
})();
